import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-printer-options',
  templateUrl: './printer-options.component.html',
  styleUrls: ['./printer-options.component.scss'],
})
export class PrinterOptionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
